import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import useDrawerA11y from './useDrawerA11y';
import '../createForms.css';

// The ONE side-drawer frame: scrim + panel + width + z-index (shell.css --z-scrim / --z-drawer) + Esc + focus trap/restore +
// aria-modal. Sizes: 'expanded' = 720 (create drawers always open here), 'standard' = 456 (record drawers; their expand tool
// toggles to 720). kind 'create' keeps the .cform-root scope + the .cf-panel / .cf-scrim alias classes that the form CSS uses.
// `after` = siblings of the panel inside the scope (the draft pill, the discard dialog). `portal` = render into document.body.
export default function DrawerFrame({ kind = 'record', size = 'standard', open = true, active = open, onClose, label, labelledBy, testId, portal = false, className = '', after = null, children, ...rest }) {
  const ref = useRef(null);
  useDrawerA11y(ref, onClose, active);
  const create = kind === 'create';
  const cls = ['drawer', create && 'cf-panel ' + size, size === 'expanded' && 'wide', open && 'open', className].filter(Boolean).join(' ');
  const body = (
    <>
      <div className={['scrim', create && 'cf-scrim', open && 'open'].filter(Boolean).join(' ')} onClick={onClose} />
      <aside ref={ref} tabIndex={-1} className={cls} role="dialog" aria-modal="true" aria-label={label} aria-labelledby={labelledBy} data-testid={testId} {...rest}>{children}</aside>
      {after}
    </>
  );
  const out = create ? <div className="cform-root">{body}</div> : body;
  return portal ? createPortal(out, document.body) : out;
}
